import MonitoredPageCheckSchedule from "@/components/domains/MonitoredPageCheckSchedule";
import type { MonitoredJourneySummary } from "@/types";

type Props = {
  journey: MonitoredJourneySummary;
};

export default function MonitoredJourneyChip({ journey }: Props) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm">
      <span className="font-medium text-gray-900">{journey.title}</span>
      <MonitoredPageCheckSchedule last_checked_at={journey.last_checked_at} next_check_at={journey.next_check_at} />
    </div>
  );
}
